import React from "react";
import { useHistory } from "react-router-dom";
import classes from "./Aside.module.scss";
import * as routes from "../../constants/routes";
import { Layout, Menu } from "antd";
import {
  IconDashboard,
  IconDashboardProto,
  IconUserBusca,
  IconExcluir,
  IconUserExcluir,
  IconAtividades,
  IconBanners,
  IconEmpresas,
  IconUsers,
  IconValidarCrfa,
  IconRecompensas,
  IconGerenciarRecompensas,
  IconEvents,
  IconAfinando,
  IconAudiofoco,
  IconAudbility,
} from "./AsideIcons";

const { Sider } = Layout;
const { SubMenu } = Menu;

const Aside = ({ className }) => {
  const history = useHistory();

  const handleNavigate = (route) => {
    if (route) history.push(route);
  };

  return (
    <Sider
      className={className}
      theme="light"
      width={300}
      style={{
        position: "fixed",
        top: "80px",
        left: 0,
        height: "calc(100vh - 80px)",
        zIndex: 1000,
        overflowY: "auto",
      }}
    >
      <div className={classes.section}>GERAL</div>

      <Menu mode="inline" theme="light">
        <Menu.Item
          key="dashboard"
          onClick={() => handleNavigate(routes.R_DASHBOARD)}
          icon={<IconDashboard className={classes.menuIcon} />}
        >
          Dashboard
        </Menu.Item>

        <Menu.Item
          key="dashboard-proto"
          onClick={() => handleNavigate(routes.R_DASHBOARD_PROTO)}
          icon={<IconDashboardProto className={classes.menuIcon} />}
        >
          Dashboard Proto
        </Menu.Item>

        <hr className={classes.divider} />

        {/* AFINANDO O CÉREBRO */}
        <SubMenu
          key="afinando-cerebro"
          title="AFINANDO O CÉREBRO"
          icon={<IconAfinando className={classes.menuIcon} />}
        >
          {/* USUÁRIOS */}
          <SubMenu
            key="afinando-cerebro-usuarios-planos"
            title="Usuários e Planos"
          >
            <Menu.Item
              key="afinando-usuarios"
              onClick={() => handleNavigate(routes.R_PLANS_USERS)}
              icon={<IconUserBusca className={classes.menuIcon} />}
            >
              Usuários
            </Menu.Item>

            <Menu.Item
              key="afinando-cancelamentos"
              onClick={() => handleNavigate(routes.R_PLANS_CANCEL)}
              icon={<IconExcluir className={classes.menuIcon} />}
            >
              Cancelamentos
            </Menu.Item>

            <Menu.Item
              key="afinando-excluir-usuario"
              onClick={() => handleNavigate(routes.R_DELETE_USER)}
              icon={<IconUserExcluir className={classes.menuIcon} />}
            >
              Excluir Usuário
            </Menu.Item>
          </SubMenu>

          {/* RECOMPENSAS */}
          <SubMenu key="afinando-cerebro-recompensas" title="Recompensas">
            <Menu.Item
              key="afinando-gerencia-recompensa"
              onClick={() => handleNavigate(routes.R_REWARDS)}
              icon={<IconGerenciarRecompensas className={classes.menuIcon} />}
            >
              Gerenciar Recompensas
            </Menu.Item>

            <Menu.Item
              key="afinando-adicionar-recompensa"
              onClick={() => handleNavigate(routes.R_ADD_REWARDS)}
              icon={<IconRecompensas className={classes.menuIcon} />}
            >
              Adicionar Recompensas
            </Menu.Item>
          </SubMenu>

          {/* ATIVIDADES */}
          <Menu.Item
            key="atividades"
            onClick={() => handleNavigate(routes.R_ACTIVITIES)}
            icon={<IconAtividades className={classes.menuIcon} />}
          >
            Atividades
          </Menu.Item>

          {/* BANNERS */}
          <Menu.Item
            key="banners"
            onClick={() => handleNavigate(routes.R_BANNERS)}
            icon={<IconBanners className={classes.menuIcon} />}
          >
            Banners
          </Menu.Item>

          {/* EVENTOS */}
          <Menu.Item
            key="eventos"
            onClick={() => handleNavigate(routes.R_EVENTS)}
            icon={<IconEvents className={classes.menuIcon} />}
          >
            Eventos
          </Menu.Item>
        </SubMenu>

        {/* AUDIOFOCO */}
        <SubMenu key="audiofoco" title="AUDIOFOCO" icon={<IconAudiofoco />}>
          <Menu.Item
            key="audiofoco-empresas"
            onClick={() => handleNavigate(routes.R_COMPANIES)}
            icon={<IconEmpresas className={classes.menuIcon} />}
          >
            Empresas
          </Menu.Item>

          <Menu.Item
            key="audiofoco-usuarios"
            onClick={() => handleNavigate(routes.R_AUDIOFOCO_USERS)}
            icon={<IconUsers className={classes.menuIcon} />}
          >
            Usuários
          </Menu.Item>
        </SubMenu>

        {/* AUDBILITY */}
        <SubMenu key="audbility" title="AUDBILITY" icon={<IconAudbility />}>
          <Menu.Item
            key="audbility-crfa"
            onClick={() => handleNavigate(routes.R_AUDBILITY_VALIDATE_CRFA)}
            icon={<IconValidarCrfa className={classes.menuIcon} />}
          >
            Validar CRFa
          </Menu.Item>

          <Menu.Item
            key="audbility-usuarios"
            onClick={() => handleNavigate(routes.R_AUDBILITY_USERS)}
            icon={<IconUserBusca className={classes.menuIcon} />}
          >
            Usuários
          </Menu.Item>
        </SubMenu>
      </Menu>
    </Sider>
  );
};

export default Aside;
